/*
 * A User represents personal information
 */

import Transform from '@app/transformers';
import Helper from '@app/helper';

const sideloaded = window['__session__'] || {};

const {
  id,
  email,
  full_name,
  storageFull,
  preferences,
  profile_picture,
  memberships,
  language,
  planTier,
  rules,
  isVerified,
  hasSkippedVerification,
  otpEnabled,
  otpEnabledAt,
  hideProfileEmail,
} = Transform.user(sideloaded.user);

export default {
  id,
  loggedIn: id || false,
  storageFull,
  full_name,
  email,
  language: language,
  profile_picture,
  memberships,
  defaults: {
    profile_picture_thumbnail_url: Helper.getAvatar(id),
  },
  preferences,
  planTier,
  rules,
  isVerified,
  hasSkippedVerification,
  otpEnabled,
  otpEnabledAt,
  hideProfileEmail,
};
